import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqs: FAQItem[] = [
  {
    question: '尾巴漫画网的韩漫是免费的吗？',
    answer: '是的，尾巴漫画网上的所有韩国漫画都是完全免费的。我们致力于为韩漫爱好者提供海量高清韩漫资源，无需付费即可畅享阅读体验。每日更新的最新韩漫同样免费开放。',
  },
  {
    question: '什么是下拉式观看模式？',
    answer: '下拉式观看模式是一种专为手机和电脑优化的阅读方式，无需翻页，只需向下滚动即可连续阅读漫画内容。这种模式带来极致流畅的阅读体验，是尾巴漫画网的核心特色之一。',
  },
  {
    question: '网站多久更新一次韩漫？',
    answer: '尾巴漫画网坚持每日更新，确保读者能够第一时间追到最新的韩国漫画章节。我们的编辑团队全天候关注韩漫动态，为您带来最新高清韩漫内容。',
  },
  {
    question: '可以在手机上阅读吗？',
    answer: '当然可以！尾巴漫画网完美适配手机、平板和电脑等多种设备。在手机上同样可以享受流畅的下拉式观看体验，随时随地畅读韩漫。',
  },
  {
    question: '如何找到我想看的韩漫？',
    answer: '您可以通过首页的热门推荐、最新更新区域快速找到热门韩漫，也可以通过分类浏览功能按恋爱言情、奇幻冒险、动作热血等类型筛选。此外，网站支持搜索功能，帮助您精准定位喜欢的作品。',
  },
  {
    question: '需要注册账号才能阅读吗？',
    answer: '不需要注册账号。尾巴漫画网所有韩漫均可直接在线阅读，无需注册或登录。我们希望为读者提供最简单便捷的免费韩国漫画阅读体验。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">关于尾巴漫画网的常见疑问解答</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
                onClick={() => toggleFAQ(index)}
              >
                <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {faq.question}
                </span>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-96 pb-4 md:pb-5 px-4 md:px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}